import { useSelector } from 'react-redux';
import { Icon3DPlan16, IconPhoto16, IconPlan16 } from '@cian/ui-kit';
import * as React from 'react';
import { selectImages, selectTour } from '../selectors';
import { EMediaType, IGallerySlide } from '../types/project';
import { IGalleryTab } from '../types/gallery';

interface IParams {
  withTour?: boolean;
}

export const useGalleryData = ({ withTour }: IParams = {}) => {
  const { images, layoutImages } = useSelector(selectImages);
  const tour = useSelector(selectTour);

  const slides: IGallerySlide[] = React.useMemo(() => {
    let slidesList = [];

    const [firstPhoto, ...restPhotos] = images.map(({ full, thumbnail }) => {
      return {
        full,
        img: full,
        thumb: thumbnail,
        type: EMediaType.Photo,
      };
    });

    if (firstPhoto) {
      slidesList.push(firstPhoto);
    }

    const layouts = layoutImages.map(({ full, thumbnail }) => {
      return {
        full,
        img: full,
        thumb: thumbnail,
        type: EMediaType.Layout,
      };
    });
    slidesList = slidesList.concat(layouts);

    if (withTour && tour) {
      slidesList.push({
        ...(firstPhoto || {}),
        type: EMediaType.Tour,
      });
    }

    slidesList = slidesList.concat(restPhotos);

    return slidesList;
  }, [images, layoutImages, tour, withTour]);

  const tabs: IGalleryTab[] = React.useMemo(() => {
    const tabsList = [];

    if (layoutImages.length) {
      tabsList.push({
        type: EMediaType.Layout,
        icon: <IconPlan16 color="white_100" />,
        title: 'Планировка',
      });
    }

    if (tour) {
      tabsList.push({
        type: EMediaType.Tour,
        icon: <Icon3DPlan16 color="white_100" />,
        title: '3D–тур по дому',
      });
    }

    if (images.length) {
      tabsList.push({
        type: EMediaType.Photo,
        icon: <IconPhoto16 color="white_100" />,
        title: `${images.length} фото`,
      });
    }

    return tabsList;
  }, [tour, images, layoutImages]);

  return { slides, tabs };
};
